import {
  getLongWeekdayDateString,
  getTimeOfDayString,
  sameDay,
} from 'us-react-components/dist/utils/date';
import { Job, JobType } from 'us-web-services';

export const parseApiDate = (value?: string): Date | null => {
  if (!value) return null;
  const parsed = new Date(value.replace(' ', 'T'));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getJobHeading = (
  job: Job,
  t: (key: string, values?: Record<string, unknown>) => string,
): string => {
  const booking = job.booking;
  if (!booking) return '';
  const start = parseApiDate(booking.start);
  const end = parseApiDate(booking.end);
  const today = new Date();
  if (!start) return '';

  if (job.type === JobType.ONE_TIME) {
    const datePart = sameDay(start, today) ? 'TODAY' : getLongWeekdayDateString(start);
    let out = `${datePart} ${getTimeOfDayString(start)} - `;
    if (end && !sameDay(start, end)) out += `${getLongWeekdayDateString(end)} `;
    if (end) out += getTimeOfDayString(end);
    return out;
  }

  const availability = job.availability ?? '';
  if (sameDay(start, today)) {
    return t('pages.jobDetail.recurringStartingToday', { availability });
  }
  if (start.getTime() < today.getTime() - 24 * 60 * 60 * 1000) {
    return t('pages.jobDetail.recurringStartingAsap', { availability });
  }
  const startDate = getLongWeekdayDateString(start);
  if (!end) return t('pages.jobDetail.recurringStarting', { availability, date: startDate });
  return t('pages.jobDetail.recurringStartingEnding', {
    availability,
    start: startDate,
    end: getLongWeekdayDateString(end),
  });
};
